import { inject, singleton } from "tsyringe";
import { WINDOW } from "../symbols";

@singleton()
export class WikiConfig {
  constructor(
    @inject(WINDOW)
    private readonly window: Window,
  ) {}

  get<T = any>(key: string): T | null {
    return this.window.mw?.config?.get(key) ?? null;
  }
}
